import { addApplicationItem, editApplicationItem, searchCategoryDetail } from "JS/API";
import { useEffect, useRef, useState } from "react";
import { 
  FaFileAlt, 
  FaListAlt, 
  FaSearch, 
  FaChevronDown, 
  FaChevronUp, 
  FaChevronRight, 
  FaChevronLeft,
  FaSave,
  FaTimes
} from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { detailModalStyles } from "utils/modalDesignSystem";

const EditApplicationForm = ({
    setEnterFloatSideBar,
    editTarget,
    onUpdateProduct,
    onAddProduct,
    usedMarkClasses,
    id,
    getDetail
}) => {
    const [product, setProduct] = useState({ category: "", items: "" });
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryData, setCategoryData] = useState([]);
    const [openGroups, setOpenGroups] = useState({});
    const [searchKeyword, setSearchKeyword] = useState("");
    const [offsets, setOffsets] = useState({});
    const [hasMore, setHasMore] = useState(true);
    const [isOpen, setIsOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    
    const resultWrapRef = useRef();
    const limit = 5;

    // 스타일 정의
    const styles = {
        container: {
            position: "fixed",
            right: "0",
            bottom: "0", 
            height: "100vh",
            backgroundColor: "#ffffff",
            zIndex: 9999,
            display: "flex",
            boxShadow: "-8px 0 30px rgba(0, 0, 0, 0.15)",
            border: "1px solid #e2e8f0",
            borderRadius: "12px 0 0 0"
        },
        leftSection: {
            width: "400px",
            backgroundColor: "#f8fafc",
            borderRight: "1px solid #e2e8f0",
            display: "flex",
            flexDirection: "column",
            borderRadius: "12px 0 0 0"
        },
        rightSection: {
            width: "450px",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column"
        },
        sectionHeader: {
            padding: "20px 24px",
            backgroundColor: "#1e293b",
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: "16px",
            fontWeight: "600",
            borderRadius: "12px 0 0 0"
        },
        headerButton: {
            background: "none",
            border: "none",
            color: "#ffffff",
            cursor: "pointer",
            padding: "8px",
            borderRadius: "6px",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        searchSection: {
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
            backgroundColor: "#ffffff"
        },
        searchInputGroup: {
            display: "flex",
            gap: "8px",
            marginBottom: "12px"
        },
        searchInput: {
            flex: 1,
            padding: "10px 12px",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            fontSize: "14px",
            transition: "border-color 0.2s ease",
            outline: "none"
        },
        searchButton: {
            padding: "10px 16px",
            backgroundColor: "#3b82f6",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: "6px"
        },
        resetButton: {
            padding: "10px 16px",
            backgroundColor: "#6b7280",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px"
        },
        resultTable: {
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "12px"
        },
        resultTh: {
            padding: "12px 16px",
            backgroundColor: "#f1f5f9",
            borderBottom: "2px solid #cbd5e1",
            fontSize: "11px",
            fontWeight: "600",
            color: "#374151",
            textAlign: "left",
            textTransform: "uppercase",
            letterSpacing: "0.05em"
        },
        resultTd: {
            padding: "12px 16px",
            borderBottom: "1px solid #e2e8f0",
            verticalAlign: "top",
            fontSize: "13px",
            color: "#1e293b"
        },
        categoryHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            padding: "8px 12px",
            backgroundColor: "#f8fafc",
            borderRadius: "6px",
            border: "1px solid #e2e8f0",
            transition: "all 0.2s ease"
        },
        categoryCode: {
            fontSize: "11px",
            fontWeight: "600",
            color: "#374151",
            marginBottom: "2px"
        },
        toggleIcon: {
            fontSize: "10px",
            color: "#6b7280"
        },
        productItem: {
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: "4px",
            transition: "all 0.2s ease",
            display: "inline-block",
            margin: "2px 4px 2px 0",
            fontSize: "12px",
            border: "1px solid transparent"
        },
        content: detailModalStyles.content,
        inputGroup: {
            marginBottom: "20px"
        },
        label: {
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
            fontSize: "14px",
            fontWeight: "600",
            color: "#374151",
            gap: "6px"
        },
        select: {
            width: "100%",
            padding: "12px 16px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            backgroundColor: "#ffffff",
            transition: "border-color 0.2s ease",
            boxSizing: "border-box",
            color: "#1f2937"
        },
        textarea: {
            width: "100%",
            minHeight: "120px",
            padding: "12px 16px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            backgroundColor: "#ffffff",
            resize: "vertical",
            fontFamily: "inherit",
            transition: "border-color 0.2s ease",
            boxSizing: "border-box",
            color: "#1f2937"
        },
        submitButton: {
            width: "100%",
            padding: "16px 20px",
            backgroundColor: "#10b981",
            color: "#ffffff",
            border: "none",
            borderRadius: "0 0 0 12px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px"
        },
        loadingText: {
            textAlign: "center",
            padding: "16px",
            color: "#6b7280",
            fontSize: "14px",
            fontStyle: "italic"
        }
    };

    useEffect(() => {
        if (editTarget) {
            const { mark_class, product_name } = editTarget;
            setProduct({
                category: `${mark_class}류`,
                items: product_name.join(", ")
            });

            const numericCategory = mark_class.padStart(2, "0");
            setSelectedCategory(numericCategory);
            loadCategoryData(numericCategory);
        } else {
            setProduct({ category: "", items: "" });
            setSelectedCategory("");
        }
    }, [editTarget]);

    useEffect(() => {
        if (selectedCategory && categoryData[selectedCategory]) {
            const groupKeys = Object.keys(categoryData[selectedCategory]);
            const openState = {};
            groupKeys.forEach(key => {
                openState[key] = true;
            });
            setOpenGroups(openState);
        }
    }, [categoryData, selectedCategory]);

    useEffect(() => {
        const el = resultWrapRef.current;
        if (!el || !hasMore || isLoading) return;

        if (el.scrollHeight <= el.clientHeight) {
            setIsLoading(true);
            loadCategoryData(selectedCategory, searchKeyword, true).finally(() => {
                setIsLoading(false);
            });
        }
    }, [categoryData, selectedCategory, hasMore]);

    const normalizeSearchResult = (dataArray) => {
        const result = {};
        dataArray.forEach((group) => {
            const code = group.similar_code;
            const items = group.products;

            if (code && Array.isArray(items)) {
                result[code] = items;
            }
        });
        return result;
    };

    const handleProductChange = (field, value) => {
        setProduct(prev => ({ ...prev, [field]: value }));

        if (field === "category") {
            const numericCategory = value.replace("류", "").padStart(2, "0");
            setSelectedCategory(numericCategory);
            setSearchKeyword("");
            loadCategoryData(numericCategory);
        }
    };

    const handleAddItemToTextarea = (itemToAdd) => {
        const currentItems = product.items;
        const itemList = currentItems.split(",").map(item => item?.trim());

        if (!itemList.includes(itemToAdd)) {
            const updatedItems = currentItems
                ? `${currentItems}, ${itemToAdd}`
                : itemToAdd;

            setProduct(prev => ({ ...prev, items: updatedItems }));
        }
    };

    const toggleGroupOpen = (groupKey) => {
        setOpenGroups(prev => ({
            ...prev,
            [groupKey]: !prev[groupKey]
        }));
    };

    const handleSearch = () => {
        if (!selectedCategory) {
            alert("먼저 상품분류(류)를 선택해 주세요.");
            return;
        }
        loadCategoryData(selectedCategory, searchKeyword);
    };

    const loadCategoryData = async (category, keyword = "", isLoadMore = false) => {
        const key = `${category}_${keyword}`;
        const currentOffset = isLoadMore ? offsets[key] || 0 : 0;

        try {
            const res = await searchCategoryDetail(currentOffset, limit, category, keyword);
            const raw = res?.data?.data || [];
            const normalized = normalizeSearchResult(raw);

            setCategoryData((prev) => ({
                ...prev,
                [category]: isLoadMore
                    ? { ...prev[category], ...normalized }
                    : normalized,
            }));

            if (raw.length === 0 || Object.keys(normalized).length === 0) {
                setHasMore(false);
            } else {
                setHasMore(true);
                setOffsets((prev) => ({
                    ...prev,
                    [key]: currentOffset + limit,
                }));
            }
        } catch (err) {
            console.error("유사군 데이터 불러오기 실패:", err);
            alert("유사군 항목을 불러오는 중 오류가 발생했습니다.");
        }
    };

    const handleScroll = () => {
        const el = resultWrapRef.current;
        if (!el || isLoading || !hasMore) return;

        const { scrollTop, scrollHeight, clientHeight } = el;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
            setIsLoading(true);
            loadCategoryData(selectedCategory, "", true).finally(() => {
                setIsLoading(false);
            });
        }
    };

    const handleSubmit = async () => {
        const newEntry = {
            mark_class: product.category.replace("류", "").padStart(2, "0"),
            product_name: product.items
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean),
        };

        if (!newEntry.mark_class || newEntry.product_name.length === 0) {
            alert("상품분류와 등록상품을 모두 입력해주세요.");
            return;
        }

        try {
            if (editTarget) {
                await editApplicationItem(id, newEntry);
                onUpdateProduct(newEntry);
            } else {
                await addApplicationItem(id, newEntry);
                onAddProduct(newEntry);
            }

            alert("저장되었습니다.");
            setEnterFloatSideBar(false);
            getDetail();
        } catch (error) {
            console.error("저장 실패", error);
            alert("저장 중 오류가 발생했습니다.");
        }
    };

    return (
        <div style={styles.container}>
            {/* 왼쪽 섹션 - 상품 검색 */}
            {isOpen && (
                <div style={styles.leftSection}>
                    <div style={styles.sectionHeader}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <FaSearch />
                            <span>{selectedCategory}류 상품 검색</span>
                        </div>
                        <button
                            style={styles.headerButton}
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            <FaChevronRight />
                        </button>
                    </div>

                    {/* 검색 영역 */}
                    <div style={styles.searchSection}>
                        <div style={styles.searchInputGroup}>
                            <input
                                type="text"
                                style={styles.searchInput}
                                value={searchKeyword}
                                onChange={(e) => setSearchKeyword(e.target.value)}
                                placeholder="항목 검색"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSearch();
                                    }
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#3b82f6';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#d1d5db';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <button
                                style={styles.searchButton}
                                onClick={handleSearch}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                            >
                                <FaSearch />
                            </button>
                        </div>
                        
                        <button
                            style={styles.resetButton}
                            onClick={() => {
                                setSearchKeyword("");
                                loadCategoryData(selectedCategory);
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                        >
                            <FaTimes />
                            초기화
                        </button>
                    </div>

                    {/* 검색 결과 */}
                    <div
                        style={{ flex: 1, overflow: 'auto' }}
                        ref={resultWrapRef}
                        onScroll={handleScroll}
                    >
                        <table style={styles.resultTable}>
                            <thead>
                                <tr>
                                    <th style={{...styles.resultTh, width: '100px'}}>유사군</th>
                                    <th style={{...styles.resultTh, width: '280px'}}>세부항목</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(categoryData[selectedCategory] || {}).map(([groupCodes, items]) => {
                                    const isGroupOpen = openGroups[groupCodes];

                                    return (
                                        <tr key={groupCodes}>
                                            <td style={styles.resultTd}>
                                                <div
                                                    style={{
                                                        ...styles.categoryHeader,
                                                        ...(isGroupOpen && {
                                                            backgroundColor: '#eff6ff',
                                                            borderColor: '#bfdbfe'
                                                        })
                                                    }}
                                                    onClick={() => toggleGroupOpen(groupCodes)}
                                                    onMouseEnter={(e) => {
                                                        if (!isGroupOpen) {
                                                            e.target.style.backgroundColor = '#f1f5f9';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isGroupOpen) {
                                                            e.target.style.backgroundColor = '#f8fafc';
                                                        }
                                                    }}
                                                >
                                                    <div>
                                                        {groupCodes.split(",").map(code => (
                                                            <div key={code} style={styles.categoryCode}>
                                                                {code}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div style={styles.toggleIcon}>
                                                        {isGroupOpen ? <FaChevronUp /> : <FaChevronDown />}
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={styles.resultTd}>
                                                {isGroupOpen && items.map((item, idx) => (
                                                    <span
                                                        key={idx}
                                                        style={styles.productItem}
                                                        onClick={() => {
                                                            if (!product.category) {
                                                                alert("상품분류를 먼저 선택해 주세요.");
                                                                return;
                                                            }
                                                            handleAddItemToTextarea(item);
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#eff6ff';
                                                            e.target.style.borderColor = '#bfdbfe';
                                                            e.target.style.color = '#3b82f6';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = 'transparent';
                                                            e.target.style.borderColor = 'transparent';
                                                            e.target.style.color = 'inherit';
                                                        }}
                                                    >
                                                        {item}
                                                        {idx < items.length - 1 ? ", " : ""}
                                                    </span>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        
                        {isLoading && (
                            <div style={styles.loadingText}>
                                로딩 중...
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* 오른쪽 섹션 - 폼 */}
            <div style={styles.rightSection}>
                <div style={styles.sectionHeader}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!isOpen && (
                            <button
                                style={styles.headerButton}
                                onClick={() => setIsOpen(true)}
                                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                <FaChevronLeft />
                            </button>
                        )}
                        <FaFileAlt />
                        <span>상품 정보 {editTarget ? '수정' : '등록'}</span>
                    </div>
                    <button
                        style={styles.headerButton}
                        onClick={() => setEnterFloatSideBar(false)}
                        onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                        <IoCloseOutline size={20} />
                    </button>
                </div>

                <div style={styles.content}>
                    {/* 상품분류 선택 */}
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>
                            <FaListAlt />
                            상품분류
                        </label>
                        <select
                            style={{
                                ...styles.select,
                                ...(editTarget && {
                                    backgroundColor: '#f9fafb',
                                    cursor: 'not-allowed',
                                    color: '#6b7280'
                                })
                            }}
                            value={product.category}
                            onChange={(e) => handleProductChange("category", e.target.value)}
                            disabled={!!editTarget}
                        >
                            <option value="">선택</option>
                            {Array.from({ length: 45 }, (_, i) => {
                                const rawNumber = i + 1;
                                const markClass = String(rawNumber).padStart(2, "0");
                                const value = `${rawNumber}류`;
                                const isUsed = usedMarkClasses?.includes(markClass);

                                if (editTarget) {
                                    if (markClass !== editTarget.mark_class) return null;
                                    return (
                                        <option key={rawNumber} value={value}>
                                            {value}
                                        </option>
                                    );
                                }

                                return (
                                    <option 
                                        key={rawNumber} 
                                        value={value} 
                                        disabled={isUsed}
                                        style={isUsed ? { color: '#9ca3af' } : {}}
                                    >
                                        {value} {isUsed ? '(사용됨)' : ''}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* 등록상품 입력 */}
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>
                            <FaListAlt />
                            등록상품 ({product.items
                                ? product.items.split(",").map(item => item.trim()).filter(Boolean).length
                                : 0}개)
                        </label>
                        <textarea
                            style={styles.textarea}
                            value={product.items}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                }
                            }}
                            onFocus={(e) => {
                                setSearchKeyword("");
                                if (product.category) {
                                    const numericCategory = product.category.replace("류", "").padStart(2, "0");
                                    setSelectedCategory(numericCategory);
                                    loadCategoryData(numericCategory);
                                }
                                e.target.style.borderColor = '#3b82f6';
                                e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#d1d5db';
                                e.target.style.boxShadow = 'none';
                            }}
                            onChange={(e) => handleProductChange("items", e.target.value)}
                            placeholder="등록할 상품을 입력하세요 (쉼표로 구분)&#10;&#10;왼쪽 검색 결과에서 항목을 클릭하여 추가할 수 있습니다."
                        />
                   
                    </div>
                </div>

                {/* 저장 버튼 */}
                <button
                    style={styles.submitButton}
                    onClick={handleSubmit}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
                >
                    <FaSave />
                    {editTarget ? '수정' : '등록'}
                </button>
            </div>
        </div>
    );
};

export default EditApplicationForm;